import { createLucideIcon } from 'lucide-react';

export const AIThinking = createLucideIcon('AIThinking', [
  [
    'path',
    {
      d: 'M13.5 22.9a1 1 0 0 1-1-.9c-.7-3.7-1.9-6.6-3.5-8.3A6.7 6.7 0 0 1 5 15c-1.4 0-2.8-.5-3.4-1.4-.5-.6-.6-1.3-.4-2 .6-1.8 2.5-2 4.2-1.8.8 0 2.1.2 3.6 1 1.2-1.7 1.8-4.6 1.8-8.7a1 1 0 0 1 2 0c.4 2.4.7 5 1.8 6.5.8 1.2 2.2 1.3 3.4 1.4h.7l1.5.2H22a1 1 0 0 1 0 2 16 16 0 0 0-5.8 1.2c-1.1.8-1.4 1-1.8 2.6-.3 1.4-.1 3 0 4.6l.2 1.2c0 .5-.4 1-1 1Zm-3-10.7c.7.7 1.4 1.7 2 2.9.5-1.9 1.2-2.5 2.6-3.4-.8-.4-1.7-1-2.3-2-.3-.3-.5-.7-.7-1.2a11 11 0 0 1-1.6 3.7Zm-6-.4c-.8 0-1.3.2-1.4.4v.2c.2.3.9.6 1.7.6a5 5 0 0 0 2.5-.7c-.7-.3-1.4-.5-2.1-.5h-.6Z',
      fill: 'currentColor',
      stroke: 'none',
    },
  ],
]);
